var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"data-tag":_vm.tag},domProps:{"innerHTML":_vm._s(_vm.t(_vm.tag))}})}
var staticRenderFns = []

export { render, staticRenderFns }